<template>
    <td colspan="2">
        <b-btn variant="success" v-on:click="create()"
           class="btn btn-sm btn-akg-dark-green btn-block btn-with-icon-white">
            <i class="fa fa-plus"
               style="color:white"
               aria-hidden="true"></i> KET hozzáadása
        </b-btn>
    </td>
</template>

<script>
export default {
  props: ["userProgram"],
  data() {
    return {
      form: new Form({
        user_program_id: ""
      })
    };
  },
  created: function() {
    $('[data-toggle="popover"]').popover({
      trigger: "focus",
      html: true
    });
  },
  methods: {
    create() {
      this.form.user_program_id = this.userProgram.id;

      this.form
        .post("ajax/kets")
        .then(newKet => this.$emit("createdKet", newKet))
        .catch(e => {
          console.log(e.errors);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CreateKet.vue